export enum IceIconsEnum {
  SENT = 'ICE-Icon-sent',
  SEEN = 'ICE-Icon-seen',
  TEMPRORY_ICON = 'ICE-Icon-Temprory-icon',
  CLOSE_FILL = 'ICE-Icon-close-fill',
  COLSE_IN_FRAME = 'ICE-Icon-colse-in-frame',
  MINUS_FILL = 'ICE-Icon-minus-fill',
  CONTRACTS = 'ICE-Icon-contracts',
  LINE_CHART_IN_FRAME = 'ICE-Icon-line-chart-in-frame',
  PROJECT_DATA = 'ICE-Icon-project-data',
  ENQUIRY_PIPELINE = 'ICE-Icon-enquiry-pipeline',
  ONBOARDING = 'ICE-Icon-onboarding',
  PROJECT_POST_REFLECTION = 'ICE-Icon-project-post-reflection',
  PROJECT_DELIVERY = 'ICE-Icon-project-delivery',
  LEAD_REVIEW_STAGE = 'ICE-Icon-lead-review-stage',
  SOUND_ON_FILL = 'ICE-Icon-sound-on-fill',
  SOUND_OFF_FILL = 'ICE-Icon-sound-off-fill',
  SOUND_ON = 'ICE-Icon-sound-on',
  SOUND_OFF = 'ICE-Icon-sound-off',
  GIF_FILE = 'ICE-Icon-GIF-file',
  SVG_FILE = 'ICE-Icon-SVG-file',
  JPG_FILE = 'ICE-Icon-JPG-file',
  MP4_FILE = 'ICE-Icon-MP4-file',
  PPTX_FILE = 'ICE-Icon-PPTX-file',
  PNG_FILE = 'ICE-Icon-PNG-file',
  PDF_FILE = 'ICE-Icon-PDF-file',
  HANG_UP = 'ICE-Icon-hang-up',
  INTRODUCTORY_MEETING = 'ICE-Icon-introductory-meeting',
  MY_ENQUIRIES = 'ICE-Icon-my-enquiries',
  CONTENT_HUB = 'ICE-Icon-content-hub',
  SCHEDULE_PLANNER = 'ICE-Icon-schedule-planner',
  PLANNING = 'ICE-Icon-planning',
  TEMPLATES_DESIGN = 'ICE-Icon-templates-design',
  TABLE = 'ICE-Icon-table',
  BRANDKIT_CROP_WITHOUT_BOARDER = 'ICE-Icon-brandkit-crop-without-boarder',
  CROP = 'ICE-Icon-crop',
  RESOLVE = 'ICE-Icon-resolve',
  ADD_REACTION = 'ICE-Icon-add-reaction',
  SPAM = 'ICE-Icon-spam',
  HEART = 'ICE-Icon-heart',
  STAR_SHAPE = 'ICE-Icon-Star-shape',
  ERASER = 'ICE-Icon-eraser',
  MARKER = 'ICE-Icon-marker',
  PENCIL = 'ICE-Icon-pencil',
  ARROW3_LINE = 'ICE-Icon-arrow3-line',
  ARROW1_LINE = 'ICE-Icon-arrow1-line',
  ARROW2_LINE = 'ICE-Icon-arrow2-line',
  V_DASH_LINE = 'ICE-Icon-v-dash-line',
  V_LINE = 'ICE-Icon-v-line',
  RECTANGLE_SHAPE = 'ICE-Icon-rectangle-shape',
  SQUARE_SHAPE = 'ICE-Icon-square-shape',
  TRIANGLE_SHAPE = 'ICE-Icon-triangle-shape',
  DISTRICT_6_SHAPE = 'ICE-Icon-district-6-shape',
  DISTRICT_8_SHAPE = 'ICE-Icon-district-8-shape',
  CIRCLE_SHAPE = 'ICE-Icon-circle-shape',
  PENDING = 'ICE-Icon-pending',
  STOP_CIRCLE = 'ICE-Icon-stop-circle',
  PAUSE_CIRCLE = 'ICE-Icon-pause-circle',
  STATUS = 'ICE-Icon-status',
  CHEVRON_CIRCLE_RIGHT = 'ICE-Icon-chevron-circle-right',
  CHEVRON_CIRCLE_LEFT = 'ICE-Icon-chevron-circle-left',
  CHEVRON_CIRCLE_UP = 'ICE-Icon-chevron-circle-up',
  CHEVRON_CIRCLE_DOWN = 'ICE-Icon-chevron-circle-down',
  CONTRACT_UP_DOWN = 'ICE-Icon-contract-up-down',
  EXPAND_HIGHT = 'ICE-Icon-expand-hight',
  CONNECTION = 'ICE-Icon-connection',
  INFO_OCTAGON = 'ICE-Icon-info-octagon',
  DRAW = 'ICE-Icon-draw',
  NEW_DESIGN = 'ICE-Icon-new-design',
  ELEMENT = 'ICE-Icon-element',
  VERSION_HISTROY = 'ICE-Icon-version-histroy',
  THICKNESS = 'ICE-Icon-thickness',
  SHUFFLE_COLOR = 'ICE-Icon-shuffle-color',
  MOVE_TO_FOLDER = 'ICE-Icon-move-to-folder',
  COPY_WITH_ARROW = 'ICE-Icon-copy-with-arrow',
  DESIGN = 'ICE-Icon-design',
  CHECK_CIRCLE_ALT = 'ICE-Icon-check-circle-alt',
  COMMENT = 'ICE-Icon-comment',
  TEXT = 'ICE-Icon-text',
  SHAPE = 'ICE-Icon-shape',
  FRAME = 'ICE-Icon-frame',
  FILE = 'ICE-Icon-file',
  REFRESH_ALT = 'ICE-Icon-refresh-alt',
  CORNER_DOWN_LEFT_FILL = 'ICE-Icon-corner-down-left-fill',
  CORNER_DOWN_LEFT = 'ICE-Icon-corner-down-left',
  VIEW_ALL_COMMENT = 'ICE-Icon-view-all-comment',
  USER_REMOVE = 'ICE-Icon-user-remove',
  USER_CHECK = 'ICE-Icon-user-check',
  USERS = 'ICE-Icon-users',
  ALERT_INFO = 'ICE-Icon-alert-Info',
  ALERT_WARNING = 'ICE-Icon-alert-warning',
  ALERT_ERROR = 'ICE-Icon-alert-error',
  SHARE_IN_FRAME_FILL = 'ICE-Icon-share-in-frame-fill',
  ALERT_SUCCESS = 'ICE-Icon-alert-success',
  BRAND_KIT = 'ICE-Icon-brand-kit',
  FORWARD = 'ICE-Icon-forward',
  BACKWARD = 'ICE-Icon-backward',
  FLIP_HORIZONTAL = 'ICE-Icon-flip-horizontal',
  FLIP_VERTICAL = 'ICE-Icon-flip-vertical',
  PROJECT = 'ICE-Icon-project',
  ALIGN_CENTER = 'ICE-Icon-align-center',
  ALIGN_DOWN = 'ICE-Icon-align-down',
  ALIGN_UP = 'ICE-Icon-align-up',
  ALIGN_LEFT = 'ICE-Icon-align-left',
  ALIGNRIGHT = 'ICE-Icon-alignright',
  ROTATE_CROP = 'ICE-Icon-rotate-crop',
  CROP_IN_FRAME = 'ICE-Icon-crop-in-frame',
  ALIGN_H_CENTER = 'ICE-Icon-align-h-center',
  FORWARD1 = 'ICE-Icon-forward1',
  ARTICLE = 'ICE-Icon-article',
  TRASH_IN_FRAME = 'ICE-Icon-trash-in-frame',
  CLEAR_CURSOR = 'ICE-Icon-clear-cursor',
  PLAY_FILL = 'ICE-Icon-play-fill',
  PLAY = 'ICE-Icon-play',
  X_OCTAGON = 'ICE-Icon-x-octagon',
  UPLOAD = 'ICE-Icon-upload',
  UNLOCK = 'ICE-Icon-unlock',
  TRASH = 'ICE-Icon-trash',
  CHECK_CIRCLE = 'ICE-Icon-check-circle',
  TEACHER = 'ICE-Icon-teacher',
  TASKS = 'ICE-Icon-tasks',
  SUB_TASK = 'ICE-Icon-sub-task',
  STAR_FILL = 'ICE-Icon-star-fill',
  SHARE = 'ICE-Icon-share',
  SHARE_FILL = 'ICE-Icon-share-fill',
  SETTING_COG = 'ICE-Icon-setting-cog',
  SETING_AS_DEFAULT = 'ICE-Icon-seting-as-default',
  SCHOOL_STAFF = 'ICE-Icon-school-staff',
  CALENDAR_EDIT = 'ICE-Icon-calendar-edit',
  SWAP = 'ICE-Icon-swap',
  REPLY = 'ICE-Icon-reply',
  SCAN = 'ICE-Icon-scan',
  PUPIL = 'ICE-Icon-pupil',
  PROJECTS = 'ICE-Icon-projects',
  PRIORITY_UP = 'ICE-Icon-priority-up',
  PLUS_SMALL = 'ICE-Icon-plus-small',
  PLUS_CIRCLE = 'ICE-Icon-plus-circle',
  PLAY_CIRCLE_FILL = 'ICE-Icon-play-circle-fill',
  TASK_PLANNING = 'ICE-Icon-task-planning',
  PIPELINES = 'ICE-Icon-pipelines',
  USERS2 = 'ICE-Icon-users2',
  PARTNERS = 'ICE-Icon-partners',
  PARENTS = 'ICE-Icon-parents',
  OPRATION = 'ICE-Icon-opration',
  OPEN_IN_NEW_TAB = 'ICE-Icon-open-in-new-tab',
  MOVE_TO_INBOX = 'ICE-Icon-move-to-inbox',
  USER_SETTING = 'ICE-Icon-user-setting',
  PENCIL1 = 'ICE-Icon-pencil1',
  LOGOUT = 'ICE-Icon-logout',
  LOGIN = 'ICE-Icon-login',
  IMAGE_FILL = 'ICE-Icon-image-fill',
  HOME = 'ICE-Icon-home',
  GO_TO = 'ICE-Icon-go-to',
  PLUS_CIRCLE_FILL = 'ICE-Icon-plus-circle-fill',
  FORBIDEN = 'ICE-Icon-forbiden',
  FILE_FILL = 'ICE-Icon-file-fill',
  FAQ = 'ICE-Icon-faq',
  OPEN_EYE_FILL = 'ICE-Icon-open-eye-fill',
  CLOSED_EYE_FILL = 'ICE-Icon-closed-eye-fill',
  EDIT = 'ICE-Icon-edit',
  CLOCK = 'ICE-Icon-clock',
  DOWNLOAD = 'ICE-Icon-download',
  DIRECTOR = 'ICE-Icon-director',
  CONSULTANTS = 'ICE-Icon-consultants',
  COLOR_PICKER = 'ICE-Icon-color-picker',
  CLOSE_CIRCLE_FILL = 'ICE-Icon-close-circle-fill',
  CLOSE_CIRCLE = 'ICE-Icon-close-circle',
  CIRCLE = 'ICE-Icon-circle',
  USER_TIE = 'ICE-Icon-user-tie',
  CARD_HOLDER = 'ICE-Icon-card-holder',
  BILLS_PLANS = 'ICE-Icon-bills_plans',
  PLUS = 'ICE-Icon-plus',
  ASSOCIATION = 'ICE-Icon-association',
  ASSOCIATES = 'ICE-Icon-associates',
  ASSIGNS = 'ICE-Icon-assigns',
  ALERT_TRIANGLE = 'ICE-Icon-alert-triangle',
  AFFILIATES = 'ICE-Icon-affiliates',
  ADMIN = 'ICE-Icon-admin',
  MINUS_IN_FRAME = 'ICE-Icon-minus-in-frame',
  PLUS_IN_FRAME_FILL = 'ICE-Icon-plus-in-frame-fill',
  PLUS_IN_FRAME = 'ICE-Icon-plus-in-frame',
  ID_CARD = 'ICE-Icon-id-card',
  SECURITY = 'ICE-Icon-security',
  PASTE = 'ICE-Icon-paste',
  MINUS_CIRCLE = 'ICE-Icon-minus-circle',
  WEBSITE = 'ICE-Icon-website',
  VOICE_OFF = 'ICE-Icon-voice-off',
  VOICE_ON = 'ICE-Icon-voice-on',
  ARROW_UP = 'ICE-Icon-arrow-up',
  CHEVRON_UP = 'ICE-Icon-chevron-up',
  UNDERLINED = 'ICE-Icon-underlined',
  STRIKE_THROUGH = 'ICE-Icon-strike-through',
  NUMBERD_LIST = 'ICE-Icon-numberd-list',
  JUSTIFIED = 'ICE-Icon-justified',
  ITALIC = 'ICE-Icon-italic',
  BULLETED_LIST = 'ICE-Icon-bulleted-list',
  BOLD = 'ICE-Icon-bold',
  ALIGN_RIGHT = 'ICE-Icon-align-right',
  ALIGN_LEFT1 = 'ICE-Icon-align-left1',
  ALIGN_CENTER1 = 'ICE-Icon-align-center1',
  IMAGE = 'ICE-Icon-image',
  LETTER_SPACING = 'ICE-Icon-letter-spacing',
  CHECK = 'ICE-Icon-check',
  T_TIP = 'ICE-Icon-t-tip',
  LIGHT_MODE = 'ICE-Icon-light-mode',
  START_RECORDING = 'ICE-Icon-start-recording',
  STAR = 'ICE-Icon-star',
  SPOTLIGHT = 'ICE-Icon-spotlight',
  SOCIAL_MEDIA = 'ICE-Icon-social-media',
  SHARE_SCEEN_STOP = 'ICE-Icon-share-sceen-stop',
  SHARE_SCREEN = 'ICE-Icon-share-screen',
  FORWARD_IN_FRAME = 'ICE-Icon-forward-in-frame',
  SETTING = 'ICE-Icon-setting',
  SEND = 'ICE-Icon-send',
  SEARCH = 'ICE-Icon-search',
  SCHEDULE_PLANNER1 = 'ICE-Icon-schedule-planner1',
  ROOM_BOOKING = 'ICE-Icon-room-booking',
  ARROW_RIGHT = 'ICE-Icon-arrow-right',
  CHEVRON_RIGHT = 'ICE-Icon-chevron-right',
  SWAP_IN_FRAME = 'ICE-Icon-swap-in-frame',
  REPORT_A_PROBLEM = 'ICE-Icon-report-a-problem',
  REFRESH = 'ICE-Icon-refresh',
  QR_CODE_IN_FRAME = 'ICE-Icon-qr-code-in-frame',
  PROFILE = 'ICE-Icon-profile',
  PLAY_CIRCLE = 'ICE-Icon-play-circle',
  PLANNING1 = 'ICE-Icon-planning1',
  PIN = 'ICE-Icon-pin',
  PAYMENT = 'ICE-Icon-payment',
  PARTICIPANT = 'ICE-Icon-participant',
  PARENT_REQUEST = 'ICE-Icon-parent-request',
  PARENT_NOTIFICATIONS = 'ICE-Icon-parent-notifications',
  NOTIFICATION = 'ICE-Icon-notification',
  NEWSLETTER = 'ICE-Icon-newsletter',
  NEWS_CHANNEL = 'ICE-Icon-news-channel',
  MORE = 'ICE-Icon-more',
  APPS = 'ICE-Icon-apps',
  DARK_MODE = 'ICE-Icon-dark-mode',
  MOBILE_ALERTS = 'ICE-Icon-mobile-alerts',
  MOBILE = 'ICE-Icon-mobile',
  MINIMIZE = 'ICE-Icon-minimize',
  MESSAGE = 'ICE-Icon-message',
  MAXIMIZE = 'ICE-Icon-maximize',
  LOCK = 'ICE-Icon-lock',
  BULLETED_LIST_ALT = 'ICE-Icon-bulleted-list-alt',
  ARROW_LEFT = 'ICE-Icon-arrow-left',
  CHEVRON_LEFT = 'ICE-Icon-chevron-left',
  LANGUAGES = 'ICE-Icon-languages',
  TAG = 'ICE-Icon-tag',
  INFO_CIRCLE = 'ICE-Icon-Info-circle',
  USER_CIRCLE_STICK = 'ICE-Icon-user-circle-stick',
  CALLS_CIRCLE = 'ICE-Icon-calls-circle',
  LOADING = 'ICE-Icon-loading',
  HELP_CENTER = 'ICE-Icon-help-center',
  GRIDE = 'ICE-Icon-gride',
  MINUS = 'ICE-Icon-minus',
  CONVERSATION = 'ICE-Icon-conversation',
  FOLDER = 'ICE-Icon-folder',
  FILTER = 'ICE-Icon-filter',
  FILE1 = 'ICE-Icon-file1',
  EYE_OPENED = 'ICE-Icon-eye-opened',
  EYE_CLOSED = 'ICE-Icon-eye-closed',
  EVENTS = 'ICE-Icon-events',
  EMOJIE = 'ICE-Icon-emojie',
  EMAIL_UNREAD = 'ICE-Icon-email-unread',
  EMAIL_READ = 'ICE-Icon-email-read',
  EMAIL_INBOX = 'ICE-Icon-email-inbox',
  EMAIL = 'ICE-Icon-email',
  EDIT_IN_FRAME = 'ICE-Icon-edit-in-frame',
  DRAFT = 'ICE-Icon-draft',
  DOWNLOAD_ATTENDANCE_LIST = 'ICE-Icon-download-attendance-list',
  ARROW_DOWN = 'ICE-Icon-arrow-down',
  CHEVRON_DOWN = 'ICE-Icon-chevron-down',
  DETENTION = 'ICE-Icon-detention',
  USER = 'ICE-Icon-user',
  COPY = 'ICE-Icon-copy',
  CLOSE = 'ICE-Icon-close',
  CLOSE_SMALL = 'ICE-Icon-close-small',
  CAPTION = 'ICE-Icon-caption',
  CAMERA_ON = 'ICE-Icon-camera-on',
  CAMERA_OFF = 'ICE-Icon-camera-off',
  CALL_OUTGOING = 'ICE-Icon-call-outgoing',
  CALL_NO_ANSWERED = 'ICE-Icon-call-no-answered',
  CALL_INCOMING = 'ICE-Icon-call-incoming',
  CALL = 'ICE-Icon-call',
  CALENDAR = 'ICE-Icon-calendar',
  BLOGS = 'ICE-Icon-blogs',
  BLOCK_IN_FRAME = 'ICE-Icon-block-in-frame',
  AUDIO_SETTING = 'ICE-Icon-audio-setting',
  ATTENDACE = 'ICE-Icon-attendace',
  ATTACHMENT = 'ICE-Icon-attachment',
  ANALYTICS = 'ICE-Icon-analytics',
  ADD_PHOTO = 'ICE-Icon-add-photo',
}
